import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import type { GetRoomQuery } from 'garaje/graphql/generated/roomba-types';
import type FeatureConfigService from 'garaje/services/feature-config';
import type RoombaGraphqlService from 'garaje/services/roomba-graphql';
import type RoomsPollingService from 'garaje/services/rooms-polling';
import type StateService from 'garaje/services/state';

export interface ResourcesResourceRouteModel {
  [x: string]: unknown;
}

interface RouteParams {
  resource_id: string;
}

interface RoomModel {
  room: GetRoomQuery['room'];
}

export default class ResourcesResourceRoute extends Route {
  @service declare store: Store;
  @service declare state: StateService;
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare featureConfig: FeatureConfigService;
  @service declare roombaGraphql: RoombaGraphqlService;
  @service declare roomsPolling: RoomsPollingService;

  async model({ resource_id }: RouteParams): Promise<ResourcesResourceRouteModel> {
    const resourceTypeId = this.currentResourceTypeId;

    let model: { [x: string]: unknown } = {};

    if (resourceTypeId === '3') {
      model = (await this.loadRoom(resource_id)) as unknown as { [x: string]: unknown };
    }

    return {
      resourceTypeId,
      ...model,
    };
  }

  get currentResourceTypeId(): string {
    const { resource_type_id } = this.paramsFor('resources.resource-type') as {
      resource_type_id: string;
    };

    return resource_type_id;
  }

  async loadRoom(room_id: string): Promise<RoomModel> {
    const room = await this.roombaGraphql.getRoom(room_id);

    if (!room) {
      void this.router.transitionTo('/not-found');
    }

    return {
      room,
    };
  }
}
